package dev.lingvo.ops.state

import dev.lingvo.ops.components.OpsLoad

data class OpsOverviewStatus(val completed: Int, val total: Int, val failed: Int, val refreshing: Boolean, val stale: Boolean) {
    val canConfirmFindings: Boolean get() = completed == total && failed == 0 && !refreshing && !stale
}

fun overviewStatus(vararg checks: OpsResourceState<*>): OpsOverviewStatus = OpsOverviewStatus(
    completed = checks.count { it.load is OpsLoad.Ready },
    total = checks.size,
    failed = checks.count { it.load is OpsLoad.Failed || it.refreshFailure != null },
    refreshing = checks.any { it.isRefreshing },
    stale = checks.any { it.refreshFailure != null || it.load is OpsLoad.OfflineStale },
)
